// extracted by mini-css-extract-plugin
export var content = "styles-module--content--i9XIT";
export var icon = "styles-module--icon--jv9gj";
export var textContainer = "styles-module--textContainer--hP8oc";
export var title = "styles-module--title--YMj10";
export var visibleContainer = "styles-module--visibleContainer--Wum2j";